module.exports = __webpack_public_path__ + "media/bootstrap-icons/caret-down-fill-3829edc5.svg";